module.exports = __webpack_public_path__ + "img/button_backtomap-Bild.f296b7c4.svg";